module.exports = __webpack_public_path__ + "static/media/group.53422fc7.svg";